import axios from "axios";
const host = process.env.REACT_APP_HOST || "";

async function getKeywords() {
  let url = `${host}/dss/keywords`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status !== 401) {
      console.error(error);
      return null;
    }
  }
}

// NEW: Function to fetch cascading options based on current selections
async function getCascadingKeywords(currentSelections) {
  let url = `${host}/dss/cascading-keywords`;
  try {
    const response = await axios.post(url, currentSelections);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status !== 401) {
      console.error("Cascading fetch error:", error);
      return null;
    }
  }
}

async function getMitigationMeasures(params) {
  let url = `${host}/dss/getMeasures`;
  try {
    const response = await axios.post(url, params);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status !== 401) {
      console.error(error);
      return null;
    }
  }
}

export { getKeywords, getMitigationMeasures, getCascadingKeywords };